/*
 * Copyright (c) Microsoft Corporation.
 * Licensed under the MIT License.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is regenerated.
 */
/** Known values of {@link ApiVersion20231101} that the service accepts. */
export var KnownApiVersion20231101;
(function (KnownApiVersion20231101) {
    /** Api Version '2023-11-01' */
    KnownApiVersion20231101["TwoThousandTwentyThree1101"] = "2023-11-01";
})(KnownApiVersion20231101 || (KnownApiVersion20231101 = {}));
/** Known values of {@link KeyValueFields} that the service accepts. */
export var KnownKeyValueFields;
(function (KnownKeyValueFields) {
    /** Key */
    KnownKeyValueFields["Key"] = "key";
    /** Label */
    KnownKeyValueFields["Label"] = "label";
    /** ContentType */
    KnownKeyValueFields["ContentType"] = "content_type";
    /** Value */
    KnownKeyValueFields["Value"] = "value";
    /** LastModified */
    KnownKeyValueFields["LastModified"] = "last_modified";
    /** Tags */
    KnownKeyValueFields["Tags"] = "tags";
    /** Locked */
    KnownKeyValueFields["Locked"] = "locked";
    /** Etag */
    KnownKeyValueFields["Etag"] = "etag";
})(KnownKeyValueFields || (KnownKeyValueFields = {}));
/** Known values of {@link SnapshotFields} that the service accepts. */
export var KnownSnapshotFields;
(function (KnownSnapshotFields) {
    /** Name */
    KnownSnapshotFields["Name"] = "name";
    /** Status */
    KnownSnapshotFields["Status"] = "status";
    /** Filters */
    KnownSnapshotFields["Filters"] = "filters";
    /** CompositionType */
    KnownSnapshotFields["CompositionType"] = "composition_type";
    /** Created */
    KnownSnapshotFields["Created"] = "created";
    /** Expires */
    KnownSnapshotFields["Expires"] = "expires";
    /** RetentionPeriod */
    KnownSnapshotFields["RetentionPeriod"] = "retention_period";
    /** Size */
    KnownSnapshotFields["Size"] = "size";
    /** ItemsCount */
    KnownSnapshotFields["ItemsCount"] = "items_count";
    /** Tags */
    KnownSnapshotFields["Tags"] = "tags";
    /** Etag */
    KnownSnapshotFields["Etag"] = "etag";
})(KnownSnapshotFields || (KnownSnapshotFields = {}));
/** Known values of {@link SnapshotStatus} that the service accepts. */
export var KnownSnapshotStatus;
(function (KnownSnapshotStatus) {
    /** Provisioning */
    KnownSnapshotStatus["Provisioning"] = "provisioning";
    /** Ready */
    KnownSnapshotStatus["Ready"] = "ready";
    /** Archived */
    KnownSnapshotStatus["Archived"] = "archived";
    /** Failed */
    KnownSnapshotStatus["Failed"] = "failed";
})(KnownSnapshotStatus || (KnownSnapshotStatus = {}));
/** Known values of {@link ConfigurationSnapshotStatus} that the service accepts. */
export var KnownConfigurationSnapshotStatus;
(function (KnownConfigurationSnapshotStatus) {
    /** Provisioning */
    KnownConfigurationSnapshotStatus["Provisioning"] = "provisioning";
    /** Ready */
    KnownConfigurationSnapshotStatus["Ready"] = "ready";
    /** Archived */
    KnownConfigurationSnapshotStatus["Archived"] = "archived";
    /** Failed */
    KnownConfigurationSnapshotStatus["Failed"] = "failed";
})(KnownConfigurationSnapshotStatus || (KnownConfigurationSnapshotStatus = {}));
/** Known values of {@link SnapshotComposition} that the service accepts. */
export var KnownSnapshotComposition;
(function (KnownSnapshotComposition) {
    /** Key */
    KnownSnapshotComposition["Key"] = "key";
    /** KeyLabel */
    KnownSnapshotComposition["KeyLabel"] = "key_label";
})(KnownSnapshotComposition || (KnownSnapshotComposition = {}));
/** Known values of {@link LabelFields} that the service accepts. */
export var KnownLabelFields;
(function (KnownLabelFields) {
    /** Name */
    KnownLabelFields["Name"] = "name";
})(KnownLabelFields || (KnownLabelFields = {}));
//# sourceMappingURL=index.js.map